import {
    CustomizationProps,
    FontFamily,
    I18n,
    MenuOrientation,
    PresetColor,
    ThemeDirection,
    ThemeMode
} from "../../../types/ConfigType";
import Config from "../../../Config";

const ThemeInitialState: CustomizationProps = {
    ...Config,
    onChangeContainer: () => {
    },
    onChangeLocalization: (lang: I18n) => {
    },
    onChangeMode: (mode: ThemeMode) => {
    },
    onChangePresetColor: (theme: PresetColor) => {
    },
    onChangeDirection: (direction: ThemeDirection) => {
    },
    onChangeMiniDrawer: (miniDrawer: boolean) => {
    },
    onChangeMenuOrientation: (menuOrientation: MenuOrientation) => {
    },
    onChangeFontFamily: (fontFamily: FontFamily) => {
    }
}

export default ThemeInitialState;